import { useState } from "react";

import styles from "../Menu.module.css";

const Icons = () => {
  const [selected, setSelected] = useState("");
  const social = [
    { name: "linkedin", link: "https://www.linkedin.com/in/reda-elkassmi/" },
    { name: "github", link: "https://github.com/relkassm" },
    { name: "mail", link: "mailto:redaelkassmi@gmail.com" },
  ];

  return (
    <>
      {social.map((item) => (
        <img
          key={item.name}
          className={selected === item.name ? styles.selected : ""}
          src={`social/${item.name}.png`}
          alt={item.name}
          onMouseEnter={() => {
            setSelected(item.name);
          }}
          onMouseLeave={() => {
            setSelected("");
          }}
          onClick={() => window.open(item.link, "_blank")}
        />
      ))}
    </>
  );
};

export default Icons;
